import React, { Fragment, useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import FormSection from '../formSection';
import localization from 'assets/localization/localization';
import DropDownInput from 'components/sales/Input/dropDownInput/dropDownInput';
import ConstantInput from 'components/sales/Input/constantInput/constantInput';
import { FormGroup } from 'react-bootstrap';
import { handleValidateObj } from 'constants/objValues/objvalues';
import Regex from 'services/utils/regex/Regex';
import FileUpload from 'components/sales/fileUpload/fileUpload';
import DatePicker from 'components/sales/datePicker/datePicker';
import { handleFormatDate } from 'constants/dateFormat/dateFormat';
import TimePicker from 'react-times';

const OtherDetails = ({
  isSupply = false,
  data,
  handleValue,
  isApartment = false,
  isB2b = false,
  isPostSupply = false,
  b2bDropDown,
  documentUploadUrl,
  documentUrlData,
  imageUploadUrl,
  videoUploadUrl,
  prefilledData = null,
  isDefalut,
}) => {
  let portForward = [];
  let corSez = [];
  let scopeCivilWork = [];
  const [categories, setCategories] = useState();
  const [toTime, setToTime] = useState(
    `${new Date().getHours()}:${new Date().getMinutes()}`
  );
  const [fromTime, setFromTime] = useState(
    `${new Date().getHours()}:${new Date().getMinutes()}`
  );
  const [port, setPort] = useState('');
  const [sez, setSez] = useState('');

  useEffect(() => {
    if ((toTime, fromTime)) {
      setOtherDtlData({
        ...otherDtlData,
        pickDate: `${fromTime}-${toTime}`,
      });
    }
  }, [toTime, fromTime]);

  useEffect(() => {
    if (b2bDropDown) {
      const { categories } = b2bDropDown;
      setCategories(categories);
    }
  }, [b2bDropDown]);

  if (isB2b === false) {
    let { portForwarding, corporateSez, scopeOfCivilWork } = data;
    portForward = portForwarding;
    corSez = corporateSez;
    scopeCivilWork = scopeOfCivilWork;
  }
  const otherDtlInput = {
    portForwarding: '',
    scope_of_civil_work: '2',
    remarks: '',
    isSEZ: '',
    po_woNumber: '',
    po_woCopy: '',
    LockIn: '',
    pickDate: new Date(),
    pickTime: '',
    categoryAlliances: { id: null, value: '' },
    categoryName: '',
    marketingSignageCount: '',
    marketingSignageType: '',
    materialPhotos: '',
    materialVideos: ''
  };
  const [otherDtlData, setOtherDtlData] = useState(otherDtlInput);
  const [totalContractList, setTotalContractList] = useState([]);
  // const [materialPhotos, setMaterialPhotos] = useState({});
  // const [materialVideos, setMaterialVideos] = useState({});
  const [approachVideo, setApproachVideo] = useState({});
  const [agreementDocument, setAgreementDocument] = useState({});

  const setToDefaultValue = () => {
    if (isDefalut === true) {
      setOtherDtlData(otherDtlInput);
      setTotalContractList([]);
      // setMaterialPhotos({});
      // setMaterialVideos({});
      setApproachVideo({});
      setAgreementDocument({});
    }
  };

  useEffect(() => setToDefaultValue(), [isDefalut]);

  useEffect(() => {
    if (
      prefilledData?.lead_data !== undefined &&
      prefilledData?.lead_data !== null
    ) {
      const {
        remarks,
        lead_category,
        lead_category_id,
      } = prefilledData?.lead_data;

      if (prefilledData?.portForwarding) {
        setPort(prefilledData?.portForwarding == 'yes' ? 'Yes' : prefilledData?.portForwarding == 'no' ? 'No' : 'Default');
        if (prefilledData?.is_sez) {
          setSez(prefilledData?.is_sez == 'yes' ? 'Yes' : prefilledData?.is_sez == 'no' ? 'No' : '');
        }
        setOtherDtlData({
          ...otherDtlData,
          remarks: remarks,
          categoryAlliances: { id: lead_category_id, value: lead_category },
          portForwarding: prefilledData?.portForwarding,
          isSez: prefilledData?.is_sez
        });
      } else {
        setOtherDtlData({
          ...otherDtlData,
          remarks: remarks,
          categoryAlliances: { id: lead_category_id, value: lead_category },
        });
      }
    }
  }, [prefilledData]);

  useEffect(() => {
    let count = 60;
    for (let i = 1; i <= count; i++) {
      if (i === 1) {
        totalContractList.push({
          name: `${i} month`,
          id: `${i} month`,
        });
      } else {
        totalContractList.push({
          name: i === 60 ? `${i}+ months` : `${i} months`,
          id: `${i} months`,
        });
      }
    }
    setTotalContractList(totalContractList);

    const formatDate = handleFormatDate(new Date(), true);

    setOtherDtlData({ ...otherDtlData, pickDate: formatDate });
  }, []);

  const onFromTimeChange = (options) => {
    const { hour, minute } = options;
    setFromTime(`${hour}:${minute}`);
  };

  const onToTimeChange = (options) => {
    const { hour, minute } = options;
    setToTime(`${hour}:${minute}`);
  };

  useEffect(() => {
    if (handleValue) {
      const otherDtlObj = {
        portForwarding: otherDtlData.portForwarding,
        remarks: otherDtlData.remarks,
        po_woNumber: otherDtlData.po_woNumber,
        po_woCopy: otherDtlData.po_woCopy,
        pickDate: otherDtlData.pickDate,
        materialPhotos: otherDtlData.materialPhotos,
        materialVideos: otherDtlData.materialVideos
      };
      if (isApartment === false || isPostSupply === true) {
        otherDtlObj.isSEZ = otherDtlData.isSEZ;
      }
      // if (isPostSupply === false) {
      //   otherDtlObj.materialPhotos = materialPhotos;
      //   otherDtlObj.materialVideos = materialVideos;
      // }
      if (isPostSupply === true) {
        otherDtlObj.agreementDocument = agreementDocument;
        otherDtlObj.approachVideo = approachVideo;
        otherDtlObj.marketingSignageCount = otherDtlData.marketingSignageCount;
        otherDtlObj.marketingSignageType = otherDtlData.marketingSignageType;
      }
      const isNotEmpty = handleValidateObj(otherDtlObj);
      if (
        isNotEmpty !== false ||
        otherDtlData.client !== '' ||
        otherDtlData.parkplus !== ''
      ) {
        handleValue({
          ...otherDtlObj,
          scope_of_civil_work: otherDtlData.scope_of_civil_work,
        });
      } else {
        handleValue(otherDtlData);
      }
    }
    if (isB2b === true) {
      let b2bObj = {
        remarks: otherDtlData.remarks,
        categoryAlliances: otherDtlData.categoryAlliances.id,
      };
      const isNotEmpty = handleValidateObj(b2bObj);
      if (isNotEmpty !== false) {
        handleValue({
          ...b2bObj,
          categoryAlliances: otherDtlData.categoryAlliances.id,
          categoryName: otherDtlData.categoryName,
        });
      }
    }
  }, [
    otherDtlData,
    agreementDocument,
    approachVideo,
  ]);

  return (
    <FormSection title={localization.otherDetails}>
      {isB2b === true ? (
        <Fragment>
          <ConstantInput
            handleChange={(val) =>
              setOtherDtlData({ ...otherDtlData, remarks: val })
            }
            label={localization.remarks}
            value={otherDtlData.remarks}
          />

          {otherDtlData.categoryAlliances?.id && (
            <Fragment>
              {otherDtlData.categoryAlliances?.id === 18 ? (
                <ConstantInput
                  handleChange={(val) =>
                    setOtherDtlData({ ...otherDtlData, categoryName: val })
                  }
                  label={localization.categoryName}
                />
              ) : null}
            </Fragment>
          )}
        </Fragment>
      ) : (
        <Fragment>
          <label className="w-100">{localization.WorkingTimingNorms}</label>
          <FormGroup>
            <label>{localization.fromTime}</label>
            <TimePicker
              theme="classic"
              timeFormat="hh:mm"
              timeMode={24}
              time={fromTime}
              onTimeChange={onFromTimeChange}
            />
          </FormGroup>
          <FormGroup>
            <label>{localization.toTime}</label>
            <TimePicker
              theme="classic"
              timeFormat="hh:mm"
              timeMode={24}
              time={toTime}
              onTimeChange={onToTimeChange}
            />
          </FormGroup>
          <DropDownInput
            data={portForward}
            label={localization.portForwarding}
            getIdValue={(val) =>
              setOtherDtlData({ ...otherDtlData, portForwarding: val.id })
            }
            value = {port}
          />
          <ConstantInput
            label={localization.remarks}
            handleChange={(val) =>
              setOtherDtlData({ ...otherDtlData, remarks: val })
            }
            value={otherDtlData.remarks}
          />
          {/* <FormGroup>
            <div>
              <label>{localization.scopeOfCivilWork}</label>
            </div>
            {scopeCivilWork
              ? scopeCivilWork.map((item, index) => {
                  return (
                    <Fragment key={index}>
                      <label htmlFor={item.id}>{item.name}</label>
                      {item.id === 1 ? (
                        <Fragment>
                          <input
                            onChange={(e) =>
                              setOtherDtlData({
                                ...otherDtlData,
                                scope_of_civil_work: item.id,
                              })
                            }
                            type="radio"
                            id={item.id}
                            checked={
                              Number(otherDtlData.scope_of_civil_work) === 1
                                ? true
                                : false
                            }
                            name={localization.scopeOfCivilWork}
                            className="mx-1"
                          />
                        </Fragment>
                      ) : (
                        <Fragment>
                          <input
                            onChange={() =>
                              setOtherDtlData({
                                ...otherDtlData,
                                scope_of_civil_work: item.id,
                              })
                            }
                            type="radio"
                            id={item.id}
                            checked={
                              Number(otherDtlData.scope_of_civil_work) === 2
                                ? true
                                : false
                            }
                            name={localization.scopeOfCivilWork}
                            className="ml-1"
                          />
                        </Fragment>
                      )}
                    </Fragment>
                  );
                })
              : localization.loading}
          </FormGroup> */}
          {isApartment === false || isPostSupply === true ? (
            <DropDownInput
              data={corSez}
              label={localization.isSEZ}
              getIdValue={(val) =>
                setOtherDtlData({ ...otherDtlData, isSEZ: val.id })
              }
              value={sez}
            />
          ) : null}
          {/* <ConstantInput
            label={localization.po_woNumber}
            handleChange={(val) =>
              setOtherDtlData({ ...otherDtlData, po_woNumber: val })
            }
            required={
              data.lead_category && data.lead_category.id === 2 ? false : true
            }
            isStarRequired={
              data.lead_category && data.lead_category.id === 2 ? false : true
            }
            errorMsg={
              otherDtlData?.po_woNumber.length > 0
                ? localization.aphaNumAllowed
                : localization.requiredpo_woNumber
            }
            regex={Regex.alphaNumeric.test(otherDtlData.po_woNumber)}
          /> */}
          <div className="mr-3 d-inline-block">
            {/* <FileUpload
              id="po_woCopy"
              accept=".pdf,.png,.jpg"
              documentUploadUrl={documentUploadUrl}
              documentUrlData={documentUrlData}
              onChange={(val) =>
                setOtherDtlData({
                  ...otherDtlData,
                  po_woCopy: val,
                })
              }
            >
              <span className="btn btn-transparent upload">
                {localization.po_woCopy}
              </span>
            </FileUpload>
            &nbsp;
            {data.lead_category && data.lead_category.id === 2 ? (
              ''
            ) : (
              <label
                className={`error ${
                  otherDtlData.po_woCopy === '' ? 'error-block' : ''
                }`}
              >
                {localization.pleaseUploadPo_woCopy}
              </label>
            )} */}
            {isPostSupply ? null : (
              <Fragment>
                <div className="btn-transparent mr-3 d-inline-block ">
                  <FileUpload
                    id="uploadSitePhotos"
                    multiple
                    accept="image/*"
                    documentUploadUrl={imageUploadUrl}
                    onChange={(val) => {
                      setOtherDtlData({ ...otherDtlData, materialPhotos: val.toString() })
                      // setMaterialPhotos(val.toString());
                    }}
                  >
                    <span className="btn btn-transparent">
                      {localization.uploadSitePhotos}
                    </span>
                  </FileUpload>
                  {/* &nbsp;
                  {data.lead_category && data.lead_category.id === 2 ? (
                    ''
                  ) : (
                    <label
                      className={`error ${
                        Object.keys(materialPhotos).length === 0
                          ? 'error-block'
                          : ''
                      }`}
                    >
                      {localization.pleaseUploadSitePhotos}
                    </label>
                  )} */}
                </div>
                <div className="btn-transparent mr-3 d-inline-block">
                  <FileUpload
                    id="uploadSiteVideos"
                    accept="video/*"
                    multiple
                    documentUploadUrl={videoUploadUrl}
                    onChange={(val) => {
                      setOtherDtlData({ ...otherDtlData, materialVideos: val.toString() })
                      // setMaterialVideos(val.toString());
                    }}
                  >
                    <span className="btn btn-transparent">
                      {localization.uploadSiteVideos}
                    </span>
                  </FileUpload>
                  {/* &nbsp;
                  {data.lead_category && data.lead_category.id === 2 ? (
                    ''
                  ) : (
                    <label
                      className={`error ${
                        Object.keys(materialVideos).length === 0
                          ? 'error-block'
                          : ''
                      }`}
                    >
                      {localization.pleaseUploadSiteVideos}
                    </label>
                  )} */}
                </div>
              </Fragment>
            )}
          </div>
          {isPostSupply === true ? (
            <Fragment>
              <DropDownInput
                data={totalContractList}
                label={localization.LockIn}
                required
                isStarRequired={true}
                errorMsg={localization.requiredLockIn}
                getIdValue={(val) =>
                  setOtherDtlData({ ...otherDtlData, LockIn: val.id })
                }
              />
              <div className="w-100 form-group">
                <FileUpload
                  id="agreementDocument"
                  documentUploadUrl={documentUploadUrl}
                  multiple
                  accept=".pdf,.png,.jpg"
                  onChange={(val) => {
                    setAgreementDocument(val.toString());
                  }}
                >
                  <span className="btn btn-transparent">
                    {localization.agreementDocument}
                  </span>
                </FileUpload>
                &nbsp;
                <label
                  className={`error ${
                    Object.keys(agreementDocument).length === 0
                      ? 'error-block'
                      : ''
                  }`}
                >
                  {localization.pleaseAgreementDocument}
                </label>
                <div className="mx-2 d-inline-block">
                  <FileUpload
                    id="approachVideo"
                    multiple
                    accept="video/*"
                    documentUploadUrl={videoUploadUrl}
                    onChange={(val) => {
                      setApproachVideo(val.toString());
                    }}
                  >
                    <span className="btn btn-transparent">
                      {localization.approachVideo}
                    </span>
                  </FileUpload>
                  &nbsp;
                  <label
                    className={`error ${
                      Object.keys(approachVideo).length === 0
                        ? 'error-block'
                        : ''
                    }`}
                  >
                    {localization.pleaseUploadApproachVideo}
                  </label>
                </div>
              </div>
              <ConstantInput
                required
                isStarRequired={true}
                errorMsg={localization.requiredmarketingSignageCount}
                label={localization.marketingSignageCount}
                handleChange={(val) =>
                  setOtherDtlData({
                    ...otherDtlData,
                    marketingSignageCount: val,
                  })
                }
              />
              <ConstantInput
                required
                isStarRequired={true}
                errorMsg={localization.requiredmarketingSignageType}
                label={localization.marketingSignageType}
                type="number"
                handleChange={(val) =>
                  setOtherDtlData({
                    ...otherDtlData,
                    marketingSignageType: val,
                  })
                }
              />
            </Fragment>
          ) : null}
        </Fragment>
      )}
    </FormSection>
  );
};
OtherDetails.propTypes = {
  isSupply: PropTypes.bool,
  data: PropTypes.any,
  handleValue: PropTypes.func,
};
export default OtherDetails;
